import api from '@/services/api'

export function parseRecebiveisJson (raw) {
  try {
    const arr = typeof raw === 'string' ? JSON.parse(raw || '[]') : (raw || [])
    return Array.isArray(arr) ? arr : []
  } catch {
    return []
  }
}

export async function toggleRecebivelPago (clienteId, item) {
  const { data: cliente } = await api.get(`/clientes/${clienteId}`)
  const list = parseRecebiveisJson(cliente.recebiveisJson)
  const idx = list.findIndex(r => r.id === item.id)
  if (idx < 0) throw new Error('Recebível não encontrado')
  const hoje = new Date().toISOString().slice(0, 10)
  const nextPago = !list[idx].pago
  list[idx] = {
    ...list[idx],
    pago: nextPago,
    dataPagamento: nextPago ? hoje : null
  }
  const { data } = await api.put(`/clientes/${clienteId}/recebiveis`, {
    recebiveisJson: JSON.stringify(list)
  })
  return parseRecebiveisJson(data?.recebiveisJson)
}
